import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || "production",
  integrations: [],
});

// const FileNew = lazy(() => import("./routes/file-new"));
// const FileRaw = lazy(() => import("./routes/file-raw"));
const FileList = lazy(() => import("./routes/file-list"));
const Editor = lazy(() => import("./editor"));
// const FileClone = lazy(() => import("./routes/file-clone"));
const FirebasePlayer = lazy(() => import("./routes/firebase-player"));

import Loader from "./components/loader";
import FirebaseContext from "./firebase-context";
import "./styles/index.css";
import { EDITOR_MODES } from "./editor/modes";

// Initialize Firebase
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyB6eGzNovZ5OwC0KnMt69xd2_1FK2H2zXM",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "tree-company-tellit.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "tree-company-tellit",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "tree-company-tellit.appspot.com",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "784257416969",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:784257416969:web:fd3a43c05acb916b219dd8",
};
const firebaseApp = initializeApp(firebaseConfig);

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  return (
    <FirebaseContext.Provider value={firebaseApp}>
      <Suspense fallback={<Loader />}>
        <BrowserRouter>
          <SentryRoutes>
            <Route path="/" exact element={<FileList />} />
            <Route path="/p/:fileId" element={<FirebasePlayer />} />
            <Route path="/p/:fileId/:demoId" element={<FirebasePlayer />} />
            {/* <Route path="/file/new" exact element={<FileNew />} /> */}
            <Route path="/file/:fileId/:editorMode" element={<Editor />} />
            {/* <Route path="/raw/:fileId" element={<FileRaw />} /> */}
            {/* <Route path="/clone/:fileId" element={<FileClone />} /> */}

            {/* Fallback URL for routes without the editorMode */}
            <Route path="/file/:fileId" element={<Navigate to={EDITOR_MODES.ELEMENTS} replace={true} />} />
          </SentryRoutes>
        </BrowserRouter>
      </Suspense>
    </FirebaseContext.Provider>
  );
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
